import axiosClient from "api/shared/AxiosClient";

const { dateRangeUriEncode } = require("utils/Utils")

class CustomersService {

    getCustomerList = (dateRanges) => {
        return {
            method: 'get',
            url: `/users?${dateRangeUriEncode(dateRanges)}`,
        }
    }

    getCustomerListWithPagination = async (selectedDateRanges, limit, skip, search) => {
        const resp = await axiosClient.get(`users/list?${dateRangeUriEncode(selectedDateRanges)}&limit=${limit}&skip=${skip}&search=${search}`);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }
    
}

const customersService = new CustomersService();
export default customersService;


